<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb"/>
    <div class="flexBox">
      <text-title mainTitle="查看当前电表" subheading="" />
      <div class="header-btn-box">
        <a @click="ToModifyDevice">修改</a>
        <a @click="strategyCenter">返回</a>
      </div>
    </div>
    <form>
      <div class="form-line">
        <div class="line-text">电表名称：</div>
        <div>{{name || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">电表编号：</div>
        <div>{{code || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">电表类型：</div>
        <div>{{meterDeviceType || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">电表厂家：</div>
        <div>{{meterDeviceManufacturerName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">电表型号：</div>
        <div>{{meterDeviceModelName || '无'}}</div>
      </div>
      <div class="form-line" >
        <div class="line-text">电表所属集中器：</div>
        <div>{{electricControlDeviceName || '无'}}</div>
      </div>
      <div class="form-line" >
        <div class="line-text">互感器配置：</div>
        <div>{{mutualInductorOnOrOff || '无'}}</div>
      </div>
      <div class="form-line" v-if="mutualInductorOnOrOff === '是'">
        <div class="line-text">互感器倍率：</div>
        <div>{{powerRate || '无'}}</div>
      </div>
      <div class="form-line" >
        <div class="line-text">电表级别：</div>
        <div>{{levelName || '无'}}</div>
      </div>
      <div class="form-line" >
        <div class="line-text">上级电表：</div>
        <div>{{parentDeviceName || '无'}}</div>
      </div>
      <div class="form-line" >
        <div class="line-text">电表所在楼栋：</div>
        <div>{{buildingName || '无'}}</div>
      </div>
      <div class="form-line" >
        <div class="line-text">电表所在房间：</div>
        <div>{{roomNumber || '无'}}</div>
      </div>
      <div class="form-line" >
        <div class="line-text">场景：</div>
        <div>{{sceneName || '无'}}</div>
      </div>
      <div class="form-line" >
        <div class="line-text">初始电量：</div>
        <div>{{electricity || '无'}}</div>
      </div>
      <div class="form-line" >
        <div class="line-text">数据上报类型：</div>
        <div v-if="useType === '1'">自动上报</div>
        <div v-if="useType === '2'">扫码上报</div>
      </div>
      <div class="form-line" >
        <div class="line-text">计费系数：</div>
        <div>{{billingFactor || '无'}}</div>
      </div>
      <div class="form-line" >
        <div class="line-text">欠费是否关闸：</div>
        <div>{{autoOffState || '无'}}</div>
      </div>
      <div class="form-line" >
        <div class="line-text">设备位置：</div>
        <div>{{location || '无'}}</div>
      </div>
      <div class="form-line" >
        <div class="line-text">备注：</div>
        <div>{{memo || '无'}}</div>
      </div>
      <div class="form-line" >
        <div class="line-text">责任人：</div>
        <div v-if="responsiblePerson && personPhone">{{responsiblePerson+'/'+personPhone || '无'}}</div>
        <div v-else>无</div>
      </div>
    </form>
  </div>
</template>

<script>
  import BreadCrumb from '../../../components/common/di-ding/common/bread-crumb'
  import {errorHandler} from '../../../utils/errorHandler'
  import InputTree from '../../../components/common/inputs/input-tree'
  import {api} from '../../api/ElectronicManagement'
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import {nSuccess} from '../../../utils/notice'

  export default {
    components: {
      TextTitle,
      Breadcrumb,
      InputTree,
      BreadCrumb
    },
    name: 'controller-current',
    data () {
      return {
        config: {
          breadcrumb: [{
            value: '智慧用电',
            name: 'electronic-over-view'
          }, {
            value: '电表管理'
          }],
        },
        name: '',
        code: '',
        meterDeviceType: '',
        deviceCode: '',
        meterDeviceManufacturerName: '',
        meterDeviceModelName: '',
        electricControlDeviceName: '',
        buildingName: '',
        roomNumber: '',
        sceneName: '',
        useType: '',
        powerOnOrOff: '',
        mutualInductorOnOrOff: '',
        powerRate: '',
        powerBeforeElectricMeter: '',
        billingFactor:'',
        electricity: '',
        whetherToCount: false,
        location: '',
        memo: '',
        autoOffState:'',

        levelList: [
          {
            name: '一级',
            code: 1
          }, {
            name: '二级',
            code: 2
          }, {
            name: '三级',
            code: 3
          }, {
            name: '四级',
            code: 4
          }, {
            name: '五级',
            code: 5
          }
        ],
        levelName: '',
        parentDeviceName: '',
        responsiblePerson:'',
        personPhone:''
      }
    },
    created () {
      this.deviceCode = this.$route.params.id
      this.getElectricByCode()
    },
    methods: {
      remoteMethod (query) {
        this.getResponsiblePersonList(query)
      },
      // 获取责任人列表
      getResponsiblePersonList (searchKey) {
        this.$axios.post(`${api.getResponsiblePersonList}?searchKey=${searchKey || ''}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let list = res.data.data
              list.forEach(it => {
                it._value = it.code
                it._label = `${it.name} / ${it.phone}`
              })
              this.responsiblePersonList = list
              let res1 = this.responsiblePersonList.find(item=>item.code===this.personCode)||{}
              this.personPhone=res1.phone
            }
          })
          .catch(errorHandler('获取责任人列表失败'))
      },
      getElectricByCode () {
        this.$axios.get(`${api.getElectricMeterByCode}/${this.deviceCode}`, {})
          .then(res => {
            let data = res.data.data
            this.name = data.name
            this.code = data.code
            this.sceneName = data.sceneName
            this.useType = data.useType
            this.meterDeviceType = data.meterDeviceType
            this.meterDeviceManufacturerName = data.meterDeviceManufacturerName
            this.meterDeviceModelName = data.meterDeviceModelName
            this.electricControlDeviceName = data.electricControlDeviceName
            this.buildingName = data.buildingName
            this.roomNumber = data.roomNumber
            this.powerRate = data.powerRate
            this.billingFactor = data.billingFactor
            this.electricity = data.electricity
            this.whetherToCount = data.whetherToCount
            if (data.powerOnOrOff === '0') {
              this.powerOnOrOff = '否'
            } else {
              this.powerOnOrOff = '是'
            }
            if (data.autoOff === '0') {
              this.autoOffState = '否'
            } else {
              this.autoOffState = '是'
            }

            this.mutualInductorOnOrOff = data.mutualInductorOnOrOff === '1' ? '是' : '否'
            this.levelList.map(v => {
              if (data.level === v.code) {
                this.levelName = v.name
              }
            })
            this.location = data.location
            this.memo = data.memo
            this.parentDeviceName = data.parentDeviceName
            this.responsiblePerson = data.personName||''
            this.personCode=data.personCode
            this.remoteMethod()
          })
          .catch(errorHandler('获取电表数据失败'))
      },
      strategyCenter () {
        this.$router.push({
          name: 'ammeter-management'
        })
      },
      ToModifyDevice () {
        this.$router.push({
          path: '/ammeter_modify/' + this.$route.params.id
        })
      }
    }
  }
</script>

<style scoped>
  .flexBox {
    display: flex;
    justify-content: space-between;
  }
  .header-btn-box {
    margin: 20px 0 10px 0;
    color: #337ab7;
    font-size: 14px;
  }
  .header-btn-box a{
    margin-right: 40px;
    cursor: pointer;
  }
  .header-btn-box a:hover{
    color: #00a0e6;
  }
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
    width: 160px;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/view/ElectronicManagement/AmmeterManagement/AmmeterCurrent.vue